import styled, { css } from 'styled-components';

export const PanelWrapper = styled.section`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const HeaderSection = styled.section`
  margin: 0px 0px 26px 0px;
  padding: 0px 45px 0px 42px;
`;

export const EditorSection = styled.section`
  color: ${({ theme }) => theme.colors.white_7};
  font-size: 15px;
  padding: 0 42px;

  .content-section iframe {
    max-width: 337px;

    .lp--fullScreenPanel & {
      max-width: initial;
    }
  }
`;

export const Header = styled.h1`
  margin: 0px 0px 15px 0px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  font-size: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 3px;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 33px;

  .hub & {
    height: 56px;
  }
`;

export const HubTopSection = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
  justify-content: flex-end;
  padding: 30px 30px;
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 3;
`;

export const ClosePanelIcon = styled.button`
  opacity: 0.6;
  transition: 0.2s opacity ease;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.colors.transparent};
  display: block;
  cursor: pointer;
  background-size: 18px 18px;
  height: 18px;
  width: 18px;
  margin: 0 0 0 25px;
  border: none;
  outline: none;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const NodeList = styled.ul`
  display: flex;
  flex-direction: column;
  font-size: 15px;
`;

export const NoImage = styled.div`
  background-color: ${({ theme }) => theme.colors.menuButtonBorder};
  border-radius: 50%;
  height: 56px;
  width: 56px;
  margin-left: -3px;
  flex-shrink: 0;
`;

export const NodeListItem = styled.li`
  background-position: 0;
  background-repeat: no-repeat;
  background-size: 15px auto;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  min-height: 26px;
  padding-left: 50px;
  position: relative;
  color: ${({ theme }) => theme.colors.white_7};
  transition: color 0.2s ease;

  &:hover,
  &:focus {
    opacity: 1;
    color: ${({ theme }) => theme.colors.white};
    transition: color 0.2s ease;
  }

  &.hub {
    font-size: 18px;
    font-weight: 700;
    height: 100%;
    margin-bottom: 20px;
    padding: 0;
    border: 2px solid ${({ theme }) => theme.colors.transparent};

    &.done img,
    &.done ${NoImage} {
      opacity: 0.5;
      background-color: ${({ theme }) => theme.colors.black_9};
      border: 2px solid ${({ theme }) => theme.colors.menuButtonBorder};
    }

    &.locked,
    &.code {
      &::after {
        content: ' ';
        position: absolute;
        left: 0px;
        top: 0px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-size: 56px;
        background-position: center center;
        transform: translate(-3px);
      }
    }

    &.locked::after {
      background-image: url('/assets/images/theme-2/icons/graph/node-locked.png');
    }

    &.code::after {
      background-image: url('/assets/images/theme-2/icons/graph/node-passwd-protected.png');
    }
  }

  &.node {
    font-size: 16px;
    justify-content: space-between;

    &:before {
      background-color: ${({ theme }) => theme.colors.black};
      background-position: 9px;
      background-repeat: no-repeat;
      border: 2px solid ${({ theme }) => theme.colors.transparent};
      border-radius: 50%;
      content: '';
      height: 33px;
      margin: 0 0 0 -50px;
      position: absolute;
      width: 33px;
    }

    &.done:before {
      border-color: ${({ theme }) => theme.colors.menuButtonBorder} !important;
    }

    &.chunk {
      &:before {
        background-image: url('/assets/images/theme-2/icons/subcat.svg');
        background-position: 8px;
        background-size: 15px auto;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/subcat.svg');
      }
    }

    &.video {
      &:before {
        background-image: url('/assets/images/theme-2/icons/video.svg');
        background-size: 10px auto;
        background-position: 11px 7px;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/video.svg');
      }
    }

    &.link {
      &:before {
        background-image: url('/assets/images/theme-2/icons/link.svg');
        background-size: 15px auto;
        background-position: 7px;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/link.svg');
      }
    }

    &.legend {
      &:before {
        background-image: url('/assets/images/theme-2/icons/concept.svg');
        background-size: 10px auto;
        border-color: ${({ theme }) => theme.colors.behaviorYellow};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/concept.svg');
      }
    }

    &.correlation {
      &:before {
        background-image: url('/assets/images/theme-2/icons/correlation.svg');
        background-size: 15px auto;
        background-position: 7px center;
        border-color: ${({ theme }) => theme.colors.behaviorPink};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/correlation.svg');
      }
    }

    &.correlation {
      &:before {
        background-image: url('/assets/images/theme-2/icons/correlation.svg');
        background-size: 15px auto;
        background-position: 7px center;
        border-color: ${({ theme }) => theme.colors.behaviorPink};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/correlation.svg');
      }
    }

    &.checklist {
      &:before {
        background-image: url('/assets/images/theme-2/icons/checklist.svg');
        background-size: 60%;
        background-position: center;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/checklist.svg');
      }
    }

    &.quiz {
      &:before {
        background-image: url('/assets/images/theme-2/icons/quiz.svg');
        background-size: 19px auto;
        background-position: 5px center;
        border-color: ${({ theme }) => theme.colors.behaviorPink};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/quiz.svg');
      }
    }

    &.task {
      &:before {
        background-image: url('/assets/images/theme-2/icons/default.svg');
        background-size: 8px auto;
        background-position: 11px center;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/default.svg');
      }
    }

    &.group {
      &:before {
        background-image: url('/assets/images/theme-2/icons/connected.svg');
        background-size: 15px auto;
        background-position: 7px;
        border-color: ${({ theme }) => theme.colors.behaviorGreen};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/connected.svg');
      }
    }

    &.evaluation {
      &:before {
        background-image: url('/assets/images/theme-2/icons/evaluation.svg');
        background-size: 10px auto;
        border-color: ${({ theme }) => theme.colors.behaviorPurple};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/evaluation.svg');
      }
    }

    &.private_blog {
      &:before {
        background-image: url('/assets/images/theme-2/icons/logbook.svg');
        background-size: 13px auto;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/logbook.svg');
      }
    }

    &.written_quiz {
      &:before {
        background-image: url('/assets/images/theme-2/icons/written_quiz.svg');
        background-size: 9px auto;
        background-position: 10px center;
        border-color: ${({ theme }) => theme.colors.behaviorBlue};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/written_quiz.svg');
      }
    }

    &.public_blog {
      &:before {
        background-image: url('/assets/images/theme-2/icons/noticeboard.svg');
        background-size: 14px auto;
        background-position: 7px;
        border-color: ${({ theme }) => theme.colors.behaviorGreen};
      }

      &.done:before,
      &.accepted:before {
        background-image: url('/assets/images/theme-2/icons/done/noticeboard.svg');
      }
    }
  }
`;

export const HubImage = styled.img`
  border-radius: 50%;
  flex-shrink: 0;
  height: 56px;
  width: 56px;
  margin-left: -3px;
`;

export const HubName = styled.span`
  margin: 0;

  .hub & {
    margin-left: 20px;
  }

  .node & {
    line-height: 20px;
  }
`;

export const Nodes = styled.div`
  margin-bottom: 40px;
`;

export const ListHeader = styled.h2`
  color: ${({ theme }) => theme.colors.grey};
  font-size: 20px;
  margin-bottom: 20px;
`;

export const Indicators = styled.div`
  display: flex;
`;

export const Indicator = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-size: cover;
  margin-right: 15px;
`;

export const Note = styled(Indicator)`
  background-color: ${({ theme, type }) =>
    type === 'notification' ? theme.colors.behaviorPink : theme.colors.behaviorYellow};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
`;

export const Accepted = styled(Indicator)`
  background-image: url('/assets/images/theme-2/icons/states/accepted.svg');
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.white_7};
  font-size: 15px;
  margin: 0 0 58px;
  padding: 0 42px;
`;

export const Description = styled.div``;

export const PasswordInput = styled.input`
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  color: v ${({ theme }) => theme.colors.grey};
  flex: 1;
  outline: none;
  display: flex;
  margin: 25px 0;
`;
